import UserOperatorListResponse, {
  UserOperatorListResponseItem,
} from "../../../../api/raily/user/operator/list/user-operator-list.response";
import UserOperatorList, { UserOperatorListItem } from "./user-operator-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserOperatorListResponseItem,
): UserOperatorListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserOperatorListResponseItem,
): UserOperatorListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createDataItem = (
  responseDataItem: UserOperatorListResponseItem,
): UserOperatorListItem => {
  return {
    email: responseDataItem.email,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    phoneNumber: createPhoneNumber(responseDataItem),
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    removalDate: responseDataItem.removedAt,
    username: responseDataItem.username,
    uuid: responseDataItem.id,
  };
};

const createData = (
  responseData: UserOperatorListResponseItem[],
): UserOperatorListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: UserOperatorListResponse): UserOperatorList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userOperatorListFactory = {
  create,
};

export default userOperatorListFactory;
